var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClapboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 256,
  height: 256
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "normal"
  }
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__a",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(2 92)"
}), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "normal"
  }
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__b",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(2 92)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__c",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "matrix(1 0 0 -1 30 122)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__c",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "matrix(1 0 0 -1 76 122)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__c",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "matrix(1 0 0 -1 122 122)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__c",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "matrix(1 0 0 -1 168 122)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__c",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "matrix(1 0 0 -1 214 122)"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "normal"
  }
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__d",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  transform: "rotate(-15.153 239.317 -32.46)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__c",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "rotate(-15.153 148.456 -758.711)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__c",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "rotate(-15.153 240.456 -67.042)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__c",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "rotate(-15.153 217.456 -239.96)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__c",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "rotate(-15.153 194.456 -412.874)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__c",
  fill: "#EBEBEB",
  style: {
    mixBlendMode: "normal"
  },
  transform: "rotate(-15.153 171.456 -585.793)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__e",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(12 147)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__e",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(12 197)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__e",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(12 231)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__f",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(86 149)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__f",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(168 149)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__g",
  fill: "#4C4C4C",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(0 58)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__h",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(14 102)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__h",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(43 102)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clapboard_svg__h",
  fill: "#333",
  style: {
    mixBlendMode: "normal"
  },
  transform: "translate(14 70)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "clapboard_svg__a",
  d: "M0 0h252v156a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "clapboard_svg__b",
  d: "M0 1a1 1 0 0 1 1-1h252a1 1 0 0 1 1 1v30a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "clapboard_svg__c",
  d: "M0 0h23.75L38 28H14.25z"
}), /*#__PURE__*/React.createElement("path", {
  id: "clapboard_svg__d",
  d: "M0 1a1 1 0 0 1 1-1h233a1 1 0 0 1 1 1v30a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "clapboard_svg__e",
  d: "M0 0h232v2H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "clapboard_svg__f",
  d: "M0 0h2v48H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "clapboard_svg__g",
  d: "M0 4a4 4 0 0 1 4-4h32.254a4 4 0 0 1 3.276 1.704l42.057 60C83.445 64.354 81.549 68 78.31 68H4a4 4 0 0 1-4-4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "clapboard_svg__h",
  d: "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0"
}))));
export default SvgClapboard;